module.exports = __webpack_public_path__ + "img/sintesis.679a1945.svg";